import React,{useState, useContext, useEffect} from "react";
import { API } from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { HeaderAdmin } from "../../components/HeaderAdmin/HeaderAdmin";
import { LateralMenu } from "../../components/LateralMenu/LateralMenu";
import { uiContext } from '../../../components/common';

export function ChangePasswordPage() {
  /**
   * Vista para cambiar el password
   * Hay un formulario donde se ingresar la contraseña actual y la nueva
   * estos datos son enviados al servidor para ser actualizados
   */
  const [newPassword, setNewPassword] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const uicontext = useContext(uiContext);
  const history = useHistory();

  const protectedRoute = ()=>{
    const sessionToken = localStorage.getItem('sessionToken');
    if(!sessionToken){
      history.push('/staff-login')
    }
  }
  
  const changePassword = ()=>{

    const sessionKey = localStorage.getItem('sessionToken');
    if(window.confirm('Cambiar contraseña?')){
      uicontext.showLoader();
      /**
       * Actualizar la contraseña
       * Se hace el llamado al servicio /staffusers/change-password-staff-user
       */        
      API.postChangePasswordStaffUser({
        sessionKey,
        oldPassword,
        newPassword
      })
        .then(x => {
          uicontext.hideLoader();
          if(x.email){
            history.push('/admin/user-requests')
            return;
          }
          alert('Algo ocurrio al intentar cambiar la contraseña, intente nuevamente.')
        })
        .catch(x =>{
          uicontext.hideLoader();
        })
    }
  }

  useEffect(()=>{
    protectedRoute();
  },[])

  return (
    <>
      <HeaderAdmin />
      <LateralMenu />
      <main className="content">
        <h2>Cambiar contraseña</h2>
        <div className="card">
          <p>Contraseña actual</p>
          <input type="text" onChange={(e) => setOldPassword(e.target.value)}/>
          <p>Contraseña nueva</p>
          <input type="text" onChange={(e) => setNewPassword(e.target.value)}/>
          <button 
          className="button-register" 
          onClick={()=>changePassword()}>Guardar cambios</button>
        </div>
      </main>
    </>
  )
}
